import { render, staticRenderFns } from "./TemplateHeaderPage.vue?vue&type=template&id=106725ab&"
import script from "./TemplateHeaderPage.vue?vue&type=script&lang=js&"
export * from "./TemplateHeaderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports